import { useEffect } from "react";
import { track } from "@flights/et-universal";
import { createTrackingUtils } from "../index.js";
import useProfiler from "../../../hooks/useProfiler.js";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import { useAppliedFilters } from "../../../hooks/search/useAppliedFilters.js";
const EXP_NAME = "flights_funnel_sr_gen_ai_summary_open_desktop_all_languages";
const EVALUATED_LANGUAGE_PREFIXES = ["es", "de", "fr", "it", "pt"];
const utils = createTrackingUtils({
    name: EXP_NAME,
    stages: {
        engAllPos: 1,
        direct: 2,
        meta: 3,
        us: 4,
        engNonUs: 5,
        nonEng: 6,
        evaluatedLanguages: 7,
        nonEvaluatedLanguages: 8,
        appliedFilters: 9
    },
    goals: {
        success: 1,
        error: 2,
        ctaClick: 3
    },
    defaultStage: 1
});
const getVariant = () => track(EXP_NAME);
const useTrackStages = () => {
    const { stages } = utils;
    const { isAmerican, isDirect, isMeta, isEnglish } = useProfiler();
    const { locale } = useGlobalContext();
    const filtersCount = useAppliedFilters().length;
    useEffect(() => {
        isDirect() && stages.direct();
        isMeta() && stages.meta();
        isAmerican() && stages.us();
        const isEng = isEnglish();
        const languagePart = (locale?.toLowerCase() || "").split("-")[0];
        const isEvaluatedLanguage = EVALUATED_LANGUAGE_PREFIXES.includes(languagePart);
        if (isEng) {
            stages.engAllPos();
            if (!isAmerican()) {
                stages.engNonUs();
            }
        }
        else {
            stages.nonEng();
            if (isEvaluatedLanguage) {
                stages.evaluatedLanguages();
            }
            else {
                stages.nonEvaluatedLanguages();
            }
        }
        filtersCount > 0 && stages.appliedFilters();
    }, [stages, isAmerican, isDirect, isMeta, isEnglish, locale, filtersCount]);
};
export default { ...utils, useTrackStages, getVariant };
